module.exports = __webpack_public_path__ + "static/img/1062.84b102b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1062.jpg
// module id = 244
// module chunks = 0